exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntextarea#description[data-v-72b9f51a] {\n\tmin-height: 100px;\n}\n.has-error .form-control[data-v-72b9f51a] {\n\tborder-color: #dc3545;\n}\n", ""]);

// exports
